//******************** */
// * Certification Search *
//****************** */
/*
    1) On page load, get any url params
    2) Update certification state object with params (state is our source of truth)
    2) then update the filters (dropdowns and search bar) based on state
    3) then ajax grab the certifications, filtered by state
    4) watch the page filters for user interaction
    4) when the user interacts with a filter
        4.1) update state
        4.2) update the url params based on state
        4.3) re-grab certifications, filtered by state
    5) when the user clicks 'reset filters', state gets reset except for search query
    The certification filtration happens on a hidden page (/views/hidden/search-ajax-request-certifications)
    Whenever certifications are grabbed an ajax request is made to get the contents of that page
    (craft queries handled on separate page so the certification index doesn't need to reload to run the queries)
    The hidden page accepts url params and uses those to filter the query it makes
    -------------------- STATE --------------------
    - the source of truth (vs params or active dropdowns)
    */

    let certifications__state = {
      query:'',
      manufacturer:'',
      state:'',
      country:'',
      class:''
  }

  /*
  -------------------- FUNCTIONS ------------------
  certifications__initialLoad()
  - get params
  - updateState(stateChange, 'params')
  certifications__updateState(stateChange, source)
  - update the state key/value
      - stateChange is an object with just the changing keys, so you can update multiple in one go
      - e.g. stateChange = { theme:"Innovation", region:"Canada"}
  - source helps us determine what needs (and doesnt need) to be updated
  - if source === reset, return all values to null except query
  - if source !== params, update url params based on this change
  - if source !== filters, call updateFilters()
  - call updateResults()
  certifications__updateFilters()
  - reset all filters
  - update filters based off state
  certifications__resetFilters()
  - resets dom filters to defaults
  certifications__updateResults()
  - send an ajax query with the url param
  - get results
  - update DOM with results
  - reinitialize the popover library handle on minor projects
  certifications__watchFilters()
  - find all filters, add eventListeners for click and keypress
  - on interaction, call updateState(stateChange, 'filters')
*/

function certifications__initalLoad(){

  const urlParams = new URLSearchParams(window.location.search);
  const queryParam = urlParams.get('query')
  const manufacturerParam = urlParams.get('manufacturer')
  const stateParam = urlParams.get('state')
  const countryParam = urlParams.get('country')
  const classParam = urlParams.get('class')

  let paramObject = {}

  if (queryParam){ paramObject['query'] = queryParam }
  if (manufacturerParam){ paramObject['manufacturer'] = manufacturerParam.toLowerCase() }
  if (stateParam){ paramObject['state'] = stateParam.toLowerCase() }
  if (countryParam){ paramObject['country'] = countryParam.toLowerCase() }
  if (classParam){ paramObject['class'] = classParam.toLowerCase() }

  certifications__updateState(paramObject)
}


function certifications__updateState(stateChange, source){
  //Update the state with the new changes (or reset them)

  if (source === "reset"){
      certifications__state['manufacturer'] = ''
      certifications__state['state'] = ''
      certifications__state['country'] = ''
      certifications__state['class'] = ''
  } else {
      if (stateChange !== null && typeof stateChange === 'object'){
          Object.entries(certifications__state).forEach(([keyA, valueA]) => {
              Object.entries(stateChange).forEach(([keyB, valueB]) => {
                  if (keyA === keyB){
                      if (valueB === null){
                          certifications__state[keyA] = ''
                      } else {
                          certifications__state[keyA] = valueB
                      }
                  }
              })
          });
      }
  }

  if (source === "reset"){
      certifications__resetFilters()
  }
  if (source !== "params"){
      let urlParams = new URLSearchParams('');
      let paramsAreEmpty = true;
      Object.entries(certifications__state).forEach(([key, value]) => {
          if (value !== ''){
              urlParams.set(key, value)
              paramsAreEmpty = false;
          }
      })
      let showParamMark = paramsAreEmpty ? '' : '?'
      window.history.replaceState({}, '', `${window.location.pathname}${showParamMark}${urlParams}`);
  }
  certifications__updateFilters()
  certifications__updateResults()
}


function certifications__resetFilters(){
  // Unhighlight any active dropdown items
  let activeDropdownItems = document.querySelectorAll('.dropdown-item--active');
  activeDropdownItems.forEach(item => {
      item.classList.remove('dropdown-item--active');
  })

  // Highlight the default "all __" option again
  document.querySelector('.all-manufacturer').classList.add('dropdown-item--active');
  document.querySelector('.all-state').classList.add('dropdown-item--active');
  document.querySelector('.all-country').classList.add('dropdown-item--active');
  document.querySelector('.all-class').classList.add('dropdown-item--active');

  // Change all dropdown inner text to "All __"
  document.querySelector('.dropdown-toggle__selection--manufacturer').innerText = "All Manufacturers";
  document.querySelector('.dropdown-toggle__selection--state').innerText = "All States";
  document.querySelector('.dropdown-toggle__selection--country').innerText = "All Countries";
  document.querySelector('.dropdown-toggle__selection--class').innerText = "All Standards";
}


function certifications__updateFilters(){
  certifications__resetFilters()
  //Loop through state and update the filter dropdowns of any active types
  Object.entries(certifications__state).forEach(([key, value]) => {
      if (key !== 'query' && value !== ''){
          let filter = document.querySelector(`.${key}-option[data-${key}=${value}]`)
          if (filter){
              document.querySelector(`.all-${key}`).classList.remove('dropdown-item--active'); //first remove the all filter
              filter.classList.add('dropdown-item--active')
              let filterTitle = filter.querySelector('span').innerHTML;
              document.querySelector(`.dropdown-toggle__selection--${key}`).innerHTML = filterTitle;
          }
      }
      else if (key !== 'query' && value === ''){
          // Add active class to "all __" option when it is clicked (i.e. no filter)
          document.querySelector(`.all-${key}`).classList.add('dropdown-item--active');
      }
      else if (key === 'query' && value !== ''){
          document.querySelector('#certifications-search').value = value;
      }
  })
}


function certifications__watchFilters(){

  ['manufacturer', 'state', 'country', 'class'].forEach(( type ) => {
      let filters = document.querySelectorAll(`.${type}-option`);
      if (filters){
          filters.forEach((filter) => {
              filter.addEventListener('click', function(e){
                  let result = {}
                  result[type] = e.currentTarget.getAttribute(`data-${type}`);
                  certifications__updateState(result, 'filters')
              })
              filter.addEventListener('keypress', function(e){
                  if(e.key === "Enter") {
                      let result = {}
                      result[type] = e.currentTarget.getAttribute(`data-${type}`);
                      certifications__updateState(result, 'filters')
                  }
              })
          })
      }
  })

  //Watch the search box
  $('#certifications-search').keyup(_.debounce(function(event){
      let result = { query : event.target.value }
      certifications__updateState(result)
  } , 500));
}


function certifications__updateResults(){

  let urlParam = window.location.search;
  let searchString = `/views/hidden/search-ajax-request-certifications${urlParam}`;

  $('.certifications-loading').fadeIn();
  $('#query-container-certifications').fadeOut();

  $.ajax(searchString, {
      dataType : 'html',
      success : function (response) {
          $('.certifications-loading').fadeOut();
          var $html = $('<div />').append(response);
          $('#query-container-certifications').html($html.find('.js-search-results--certifications').html()).fadeIn();
          //Prep the popovers
          var dynamic_popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
          var dynamic_popoverList =  dynamic_popoverTriggerList.map(function (popoverTriggerEl) {
              return new bootstrap.Popover(popoverTriggerEl)
          })
          $('#query-container-certifications').fadeIn();
      }
  });
}


// ------------ Initialize --------------------------

if (document.querySelector('#certifications-search')){
  certifications__initalLoad()
  certifications__watchFilters()

  const resetFiltersBtn = document.querySelector('.reset-all-filters__button');
  if(resetFiltersBtn){
      resetFiltersBtn.addEventListener('click', () => {
          certifications__updateState(null, 'reset')
      })
  }
}
